import { useTranslation } from 'react-i18next';
import { TimePicker } from '../timePicker';
import { changeEnd, changeStart } from './helpers';
import { TimeRangePickerProps } from './types';

export const TimeRangePicker = ({ id, value, onChange, disabled }: TimeRangePickerProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'forms' });

  return (
    <div className="flex items-center gap-3.5 max-[899px]:flex-col max-[899px]:items-stretch max-[899px]:gap-1.5">
      <TimePicker
        id={`${id}-start`}
        label={t('startTime.label')}
        value={value?.start}
        disabled={disabled}
        onChange={(start) => value && onChange?.(changeStart(value, start))}
      />
      <span className="font-semibold text-neutral-400 max-[899px]:hidden" aria-hidden>
        -
      </span>
      <TimePicker
        id={`${id}-end`}
        label={t('endTime.label')}
        value={value?.end}
        disabled={disabled}
        onChange={(end) => value && onChange?.(changeEnd(value, end))}
      />
    </div>
  );
};
